module.exports = __webpack_public_path__ + "img/motor_no37.07cd5f6b.jpg";